import { ButtonWithIcon } from "@cabocheck/shared";
import { Link } from "react-router";
import { useTranslation } from "react-i18next";
import { assets } from "~/assets";

export function LanddingBoxContainer({ children }: { children: React.ReactNode }) {
  const { t } = useTranslation();
  return (
    <div className="flex min-h-[750px] overflow-hidden bg-white">
      <div className={`relative flex flex-1 bg-black`}>
        <img
          src={assets["./landing_box.webp"]!}
          alt="rocket"
          className="absolute bottom-0 left-0 right-0 top-0 z-0 h-full w-full object-cover opacity-75"
        />
        {children ? null : (
          <div className="container z-10 flex justify-center">
            <div className="grid gap-8 text-white sm:w-1/2">
              <h1 className="font-[Merriweather] [text-shadow:_-3px_2px_3px_rgb(0_0_0_/_40%)]">
                {t("Sie interessieren sich für CaboCheck?")}
              </h1>
              <p>{t("Melden Sie sich hier an. Damit wir Sie rechtzeitig kontaktieren können.")}</p>
              <Link to="/register/pharmacy/step2">
                <ButtonWithIcon icon={assets["./icons/Arrow-forward.svg"]!}>{t("Ich habe Interesse")}</ButtonWithIcon>
              </Link>
            </div>
          </div>
        )}
      </div>
      {children ? <div className="flex w-full items-center p-8 sm:w-2/3 sm:p-14">{children}</div> : null}
    </div>
  );
}
